module.exports = __webpack_public_path__ + "static/media/achievement-digital-dinner-date.980124ad.svg";